import { createAsyncThunk } from "@reduxjs/toolkit";
import { companySliceName } from "..";
import server from "../../../../config/server";

export const insertTimeframeAction = createAsyncThunk(`${companySliceName}/insertTimeframe`, async (data) => {
  const response = await server.post("/app/timeframe", data);
  return response.data;
});

export const updateTimeframeAction = createAsyncThunk(`${companySliceName}/updateTimeframe`, async (data) => {
  const response = await server.put("/app/timeframe", data);
  return response.data;
});

export const getTimeframesAction = createAsyncThunk(`${companySliceName}/getTimeframes`, async (_, thunkAPI) => {
  try {
    const response = await server.get("/app/timeframe/views", {}, {});
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteTimeframeAction = createAsyncThunk(`${companySliceName}/deleteTimeframe`, async (uuid) => {
  const response = await server.delete(`/app/timeframe?uuid=${uuid}`);
  return response.data;
});
